export const state = {
    recentBookings: [],
    stampStatistics: {},
    acteStampStatistics: {},
    // stampStatistics: {},
    activeStructure: null,
    deCount: {},
    activiteCount: {},
}